import { useMutation } from '@tanstack/react-query';
import onlinePaymentsApi from '@/features/dashboard/onlinePayments/api/onlinePaymentsApi.ts';
import { AdminInitiatePaymentRequest } from '@/features/dashboard/onlinePayments/types/AdminInitiatePaymentRequest.ts';
import { toast } from 'sonner';

export default function useInitiateOnlinePayment() {
  return useMutation({
    mutationFn: (dto: AdminInitiatePaymentRequest) =>
      onlinePaymentsApi.initiate(dto),
    onSuccess: (data) => {
      if (data.paymentUrl) {
        window.open(data.paymentUrl, '_blank');
      }
      toast.success('Płatność została zainicjowana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas inicjowania płatności.',
      });
    },
  });
}
